<template>
	<div>
		<el-table :data="tableData" style="width: 100%" :default-sort="{prop: 'date', order: 'descending'}"
			v-loading="loading" border>
			<el-table-column header-align="center" align="center" prop="role_code" label="角色编码" sortable width="180">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="role_name" label="角色名称" width="180">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="role_type" label="业务身份">
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="is_admin" label="是否管理员">
        <template slot-scope="scope">
          <el-tag
              :type="scope.row.is_admin.value === 'Y' ? 'success' : 'danger'"
              disable-transitions>{{scope.row.is_admin.text}}</el-tag>
        </template>
			</el-table-column>
			<el-table-column header-align="center" align="center" prop="modify_time" label="上次操作时间">
			</el-table-column>
		</el-table>
		<!-- 分页部分 -->
		<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:page-sizes="[10,20,50,100]" :page-size="page_size" :total="total"
			layout="total, sizes, prev, pager, next, jumper" style="text-align: right"></el-pagination>
	</div>
</template>

<script>
	export default {
		name: "roleInformation",
		data() {
			return {
				loading: true, //列表loadding
				page_size: 10, //条数
				total: 0, //总数
				tableData: [],
				page: 1 //页数
			}
		},
		mounted() {
			this.getData({
				page: 1,
				page_size: 10
			});
		},
		methods: {
			//分页
			handleCurrentChange(page) { //当前选中页
				this.page = page;
				this.getData({
					page: this.page,
					page_size: this.page_size
				});
			},
			handleSizeChange(limit) { //条数
				this.page_size = limit;
				this.page = 1;
				this.getData({
					page: this.page,
					page_size: this.page_size
				});
			},
			getData(params) { //初始化数据
				this.loading = true;
				this.$api.post("/api/system/roleList?page=" + params.page, params, res => {
					if (res.status == 200) {
						let tableData = res.data;
						this.total = tableData.total; //总数
						this.tableData = tableData.list;
					} else {
						this.$message.error(res.msg);
					}
					//渲染结束后取消加载
					this.loading = false;
				})
			},
		}
	}
</script>

<style scoped>

</style>
